module.exports = __webpack_public_path__ + "static/media/contents_shikomi.7ad6d6be.png";